// import type { SubscriptionPlan } from '@affine/graphql';
import type { PricesQuery } from '@affine/graphql';
import {
  catchErrorInto,
  effect,
  Entity,
  fromPromise,
  LiveData,
  mapInto,
  onComplete,
  onStart,
  smartRetry,
  exhaustMapWithTrailing,
} from '@toeverything/infra';
import { exhaustMap, tap } from 'rxjs';

import type { ServerService } from '../services/server';
import type { SubscriptionStore } from '../stores/subscription';
import type { AddonPrice } from '../types';

export class SubscriptionPrices extends Entity {
  prices$ = new LiveData<PricesQuery['prices'] | null>(null);
  // new LiveData<Array<{
  //   plan: SubscriptionPlan;
  //   priciongCurrency: string;
  //   monthlyOriginalAmount: number;
  //   monthlySellingAmount: number;
  //   yearlyOriginalAmount: number;
  //   yearlySellingAmount: number;
  //   monthlyId: number;
  //   monthlyChannelProductId: string;
  //   yearlyId: number;
  //   yearlyChannelProductId: string;
  //   lifetimeAmount: number;
  // }> | null>(null);
  addonPrice$ = new LiveData<Array<AddonPrice>>([]);
  isRevalidating$ = new LiveData(false);
  error$ = new LiveData<any | null>(null);

  proPrice$ = this.prices$.map(prices =>
    prices ? prices.find(price => price.plan === 'Pro') : null
  );
  aiPrice$ = this.prices$.map(prices =>
    prices ? prices.find(price => price.plan === 'AI') : null
  );
  teamPrice$ = this.prices$.map(prices =>
    prices ? prices.find(price => price.plan === 'Team') : null
  );

  readableLifetimePrice$ = this.proPrice$.map(price =>
    price?.lifetimeAmount
      ? `$${price.lifetimeAmount.toFixed(2).replace(/\.0+$/, '')}`
      : ''
  );

  constructor(
    private readonly serverService: ServerService,
    private readonly store: SubscriptionStore
  ) {
    super();
  }

  revalidate = effect(
    exhaustMap(() => {
      return fromPromise(async signal => {
        const serverConfig = this.serverService.server.features$.value;

        if (!serverConfig.payment) {
          // No payment feature, no subscription
          return [];
        }
        return this.store.fetchSubscriptionPrices(signal);
      }).pipe(
        smartRetry(),
        mapInto(this.prices$),
        catchErrorInto(this.error$),
        onStart(() => this.isRevalidating$.next(true)),
        onComplete(() => this.isRevalidating$.next(false))
      );
    })
  );

  revalidateAddon = effect(
    exhaustMapWithTrailing(() => {
      return fromPromise(async () => {
        return this.store.fetchAddonPrices();
      }).pipe(
        tap(addonPrices => {
          this.addonPrice$.next(addonPrices);
        }),
        catchErrorInto(this.error$),
        onStart(() => this.isRevalidating$.next(true)),
        onComplete(() => this.isRevalidating$.next(false))
      );
    })
  );
}
